import { getSubcategory } from '../lib'
import { useSubcategories } from './use-subcategories'

export function useSubcategory({ category }: { category: string | null | undefined }) {
  const subcategories = useSubcategories()
  return getSubcategory({ category, subcategories })
}
